import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { sponsorSchema } from '../../../schemas'

export default function New({ account, accounts, navigation }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Sponsor"
    >
      <BackLink href="/manage/sponsors">Back to Sponsors</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={sponsorSchema}
          resource="sponsor"
          endpoint="/manage/sponsors"
          backLink="/manage/sponsors"
          submitLabel="Create Sponsor"
          defaultValues={{
            name: '',
            url: '',
            short_description: '',
            logo: null
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="url"
                label="Website URL"
                type="url"
                placeholder="https://..."
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="short_description"
                label="Short Description"
                type="textarea"
                rows={2}
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="logo"
                label="Logo"
                type="file"
                accept="image/*"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
